"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EFacilityMonthlyBillingBatchStatus;
(function (EFacilityMonthlyBillingBatchStatus) {
    EFacilityMonthlyBillingBatchStatus["NOT_PAID"] = "NOT_PAID";
    EFacilityMonthlyBillingBatchStatus["PAID"] = "PAID";
})(EFacilityMonthlyBillingBatchStatus = exports.EFacilityMonthlyBillingBatchStatus || (exports.EFacilityMonthlyBillingBatchStatus = {}));
var EZuntaInvoiceStatus;
(function (EZuntaInvoiceStatus) {
    EZuntaInvoiceStatus["PAID"] = "PAID";
    EZuntaInvoiceStatus["NOT_PAID"] = "NOT_PAID";
    EZuntaInvoiceStatus["NO_PAYMENT_METHOD"] = "NO_PAYMENT_METHOD";
    EZuntaInvoiceStatus["REJECTED"] = "REJECTED";
    EZuntaInvoiceStatus["REFUND"] = "REFUND";
})(EZuntaInvoiceStatus = exports.EZuntaInvoiceStatus || (exports.EZuntaInvoiceStatus = {}));
var EZuntaInvoiceType;
(function (EZuntaInvoiceType) {
    EZuntaInvoiceType["MONTHLY"] = "MONTHLY";
    EZuntaInvoiceType["MAILING"] = "MAILING";
    EZuntaInvoiceType["CC"] = "CC";
    EZuntaInvoiceType["ECHECK"] = "ECHECK";
})(EZuntaInvoiceType = exports.EZuntaInvoiceType || (exports.EZuntaInvoiceType = {}));
var EZuntaInvoiceEmailStatus;
(function (EZuntaInvoiceEmailStatus) {
    EZuntaInvoiceEmailStatus["EMAILED"] = "EMAILED";
    EZuntaInvoiceEmailStatus["REJECTED_EMAIL"] = "REJECTED_EMAIL";
    EZuntaInvoiceEmailStatus["NOT_EMAILED"] = "NOT_EMAILED";
})(EZuntaInvoiceEmailStatus = exports.EZuntaInvoiceEmailStatus || (exports.EZuntaInvoiceEmailStatus = {}));
var EBillingBatchHistoryType;
(function (EBillingBatchHistoryType) {
    EBillingBatchHistoryType["CREATED"] = "CREATED";
    EBillingBatchHistoryType["UPDATED"] = "UPDATED";
    EBillingBatchHistoryType["COMPLETE"] = "COMPLETE";
    EBillingBatchHistoryType["INCOMPLETE"] = "INCOMPLETE";
    EBillingBatchHistoryType["CUSTOM"] = "CUSTOM";
})(EBillingBatchHistoryType = exports.EBillingBatchHistoryType || (exports.EBillingBatchHistoryType = {}));
var EBillingHistoryType;
(function (EBillingHistoryType) {
    EBillingHistoryType["CREATED"] = "CREATED";
    EBillingHistoryType["BILLED"] = "BILLED";
    EBillingHistoryType["RECREATED"] = "RECREATED";
    EBillingHistoryType["STATUS_CHANGE"] = "STATUS_CHANGE";
    EBillingHistoryType["EMAILED"] = "EMAILED";
    EBillingHistoryType["CUSTOM"] = "CUSTOM";
    EBillingHistoryType["EMAIL_REJECTED"] = "EMAIL_REJECTED";
})(EBillingHistoryType = exports.EBillingHistoryType || (exports.EBillingHistoryType = {}));
